<template>
<div>
  <div class="box" v-for="assessor in attributeType.assessors" :key="assessor.id">
    <h4 class="title is-5 is-marginless">{{ assessor.type.name }}</h4>
    
    <p class="has-text-grey">{{ assessor.type.description }}</p>

    <p class="has-text-danger" v-if="assessor.type.standard_fed">
      This assessor receives it's secure setting value from the respective standards it is associated with.
    </p>
    <p class="has-text-danger" v-else>
      This assessor does not verify against a secure setting on a standard. It's finding is self evident.
    </p>

    <div v-if="assessor.checkpoint">
      <hr>
      <div class="columns">
        <div class="column">
          <p class="has-text-weight-bold has-text-primary">Checkpoint</p>
          <p class="has-text-grey">{{ assessor.checkpoint.value }}</p>
        </div>
      </div>
      
      <div class="columns">
        <div class="column">
          <p class="has-text-weight-bold has-text-primary">Associated Standards</p>
        </div>
      </div>

      <div v-for="section in assessor.checkpoint.sections" :key="section.id">
        <div class="columns">
          <div class="column">
            {{ section.standard.name }}
          </div>
          <div class="column is-narrow">
            <span v-if="assessor.type.standard_fed">
              {{ section.setting.secure_setting }}
            </span>
            <span v-else>
              Setting not required
            </span>
          </div>
        </div>
      </div>
    </div>

  </div>

  <p class="has-text-centered" v-if="!attributeType.assessors.length">
    No assessors currently set of this attribute type.
    <br>
    Assessors are created from with Checkpoints on Standards.
  </p>
  
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters('attributeType', [
      'attributeType'
    ])
  }

}
</script>